<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="菜单名称：">
            <el-input v-model="query.resName" placeholder="请输入菜单名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态" prop="hidden">
            <el-select v-model="query.hidden" placeholder="请状态" clearable size="small">
              <el-option label="显示" :value="false"></el-option>
              <el-option label="隐藏" :value="true"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" plain>新增</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
          <el-button type="info" plain icon="el-icon-sort" size="mini" @click="toggleExpandAll">展开/折叠</el-button>
        </div>
      </div>
      <el-table v-if="refreshTable" v-loading="listLoading" :data="list" row-key="id" :default-expand-all="isExpandAll" border stripe :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" @sort-change="sortChange">
        <el-table-column prop="resName" label="菜单名称" :show-overflow-tooltip="true" min-width="200"></el-table-column>
        <el-table-column prop="icon" label="图标" align="center" min-width="60">
          <template slot-scope="{row}">
            <div class="icon-row" v-if="row.icon">
              <i :class="row.icon" class="sle-icon"></i>
              <!-- <svg-icon :icon-class="row.icon" /> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="菜单类型">
          <template slot-scope="{row}">
            {{ row.resType === 1?'目录':(row.resType === 2?'菜单':'按钮') }}
          </template>
        </el-table-column>
        <el-table-column prop="permissionIdentification" label="权限标识" :show-overflow-tooltip="true" min-width="160"></el-table-column>
        <el-table-column prop="" label="组件路径" :show-overflow-tooltip="true" min-width="200">
          <template slot-scope="{row}">
            {{ row.resCode || row.componentUrl }}
          </template>
        </el-table-column>
        <el-table-column label="是否显示" min-width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag type="error" v-if="row.hidden">否</el-tag>
            <el-tag type="success" v-else>是</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="排序号" min-width="100" align="center" sortable="custom"></el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="handleUpdate(scope.row)" >修改</el-button>
            <!-- <el-button type="text" @click="handleAdd(scope.row)" v-hasPermi="['system:menu:add']">新增</el-button> -->
            <el-button type="text" @click="handleDeleteSingle(scope.row)" >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" /> -->
    </el-card>
    <!-- 新建表单 -->
    <sysMenu-add ref="sysMenuAdd" @created="doQueryList({ pageNo: 1 })" />
    <!-- 编辑表单 -->
    <!-- <sysMenu-edit ref="sysMenuEdit" @updated="doQueryList({})" /> -->
    <!-- 查看表单 -->
    <!-- <sysMenu-show ref="sysMenuShow" /> -->
  </div>
</template>

<script>
import sysMenuAdd from './add'
import sysMenuApi from '@/api/system/sysMenu'
import enums from '@/utils/enums'
import Pagination from '@/components/Pagination'

export default {
  name: 'SysMenuTable',
  components: {
    Pagination,
    sysMenuAdd
  },
  filters: {
    findEnumLabel: enums.findEnumLabel
  },
  data() {
    return {
      enums: {
        menuType: enums.getMenuType()
      },
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 1000,
        hidden: undefined,
        resName: undefined,
        orderNoSortSign: 1,
      },
      selectItems: [],
      // 是否展开，默认全部折叠
      isExpandAll: false,
      // 重新渲染表格状态
      refreshTable: true,
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 1000 })
    },
    /** 展开/折叠操作 */
    toggleExpandAll() {
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(() => {
        this.refreshTable = true;
      });
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'orderNo': 'orderNoSortSign',
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return sysMenuApi.fetchList(this.query).then(({ data }) => {
        this.list = this.handleTree(data.list, "id");
        // this.total = data.total
      })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysMenuApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择菜单')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysMenuApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.sysMenuAdd.handleCreate()
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$refs.sysMenuShow.handleShow(row.id)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.sysMenuAdd.handleUpdate(row)
    }
  }
}
</script>
